module.exports = __webpack_public_path__ + "static/media/icon_report.ffc6191b.png";